module.exports = __webpack_public_path__ + "static/pic01-e3592ed1674cfec5862a531475aea45d.jpg";